<template>
  <keep-alive>
    <slot></slot>
  </keep-alive>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  isGlobal: true,
  name: "KeepAliveCom",
  props: {},
  emits: [],
  setup(props, { emit }) {
    return {};
  },
});
</script>
